import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SelectImage from './SelectImage';
import styles from './PageEdit.module.css';

const API_URL = process.env.NODE_ENV === "development"
  ? "http://localhost:3000/"
  : "https://api.hillerodfrimenighed.dk/";

function extractFileId(imageUrl) {
  if (!imageUrl) return null;
  return imageUrl.split("/proxyImage/")[1]?.split("?")[0] || null;
}

/**
 * 
 * @param {string} props.value - if the json data has a image url, it is given here
 * @param {Function} updateField - Function to update the parent state.
 * @example <ImageSelector value={imageUrl} updateField={(val) => updateField(sectionKey,'imageUrl', val)} />
 */

export default function ImageSelector({ value, updateField }) {
  const [selectedUrl, setSelectedUrl] = useState(value);
  const [fileName, setFileName] = useState("");

  // Look up the Drive file's saved name whenever the selected image changes,
  // so it can be shown as a hover tooltip on the thumbnail.
  useEffect(() => {
    const fileId = extractFileId(selectedUrl);
    console.log("fileId", fileId);
    if (!fileId) {
      setFileName("");
      return;
    }

    let cancelled = false;
    axios.get(`${API_URL}drive/fileName/${fileId}`)
      .then(res => { if (!cancelled) setFileName(res.data.name); console.log("fileName", res.data.name); })
      .catch(() => { if (!cancelled) setFileName(""); });

    return () => { cancelled = true; };
  }, [selectedUrl]);

  const handleSelect = (url) => {
    setSelectedUrl(url);
    updateField(url);
  };

  return (
    <div className={styles.imageSelector}>
      {selectedUrl ? (
        <div style={{ marginBottom: '0.5rem' }}>
          <img
            src={selectedUrl}
            alt={fileName || "Selected"}
            title={fileName}
            style={{ maxHeight: 200, display: 'block' }}
          />
        </div>
      ) : (
        <p>Intet billede valgt endnu.</p>
      )}

      <SelectImage onSelect={handleSelect} />
    </div>
  );
}